type GetFio = (props: { lastName?: string; firstName?: string; middleName?: string }) => string;

export const getFio: GetFio = (props = {}) => {
  return [props?.lastName, props?.firstName, props?.middleName].filter(Boolean).join(" ");
};
